import { put, call } from "redux-saga/effects";
import { performGetRequest } from "../../services/apiServices/AxiosUtils";

//-----------------------------------------------------------------------------------
export const getBuildingBetterApiData = function* BuildingBetter(action) {
  yield put({ type: "SHOW_LOADER" });

  try {
    const path = action.path;
    const res = yield call(performGetRequest, path, action.isBuildingBetter);
    if (res !== undefined && res.data.status === "success") {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

export const getBuildingBetterOverviewApiData = function* BuildingBetter(action) {
  yield put({ type: "SHOW_LOADER" });

  try {
    const path = action.path;
    const res = yield call(performGetRequest, path);
    if (res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
